import {Kysely} from 'kysely';

import {FileClient} from '@/modules/files/files_module';

import Add_audio_waveform_data from './1-add_audio_waveform_data';
import {DB} from '@/store/kysely_types';
import {DBObjects} from '@/store/store_types';
import Add_file_revision_data from './2-add_file_revision_data';
import Backfill_file_hashes from './3-backfill_file_hashes';
import Migrate_chord_lyrics_to_json from './4-migrate_chord_lyrics_to_json';

type DataMigrationRunnerProps = {
    db: Kysely<DB>;
    getFileSrc: (file: DBObjects['File'] & {full_path?: string}) => Promise<string>;
    decodeAudioData: (arrayBuffer: ArrayBuffer) => Promise<AudioBuffer>;
}

export type DataMigration = {
    name: string;
    run: (props: DataMigrationRunnerProps) => Promise<void>;
}

export const dataMigrations = [
    {
        name: '20250514052140_add_audio_waveform_data',
        run: async (props: DataMigrationRunnerProps) => {
            await Add_audio_waveform_data(props);
        }
    },
    {
        name: '20250708193325_add_file_revision_data',
        run: async (props: DataMigrationRunnerProps) => {
            await Add_file_revision_data(props);
        }
    },
    {
        name: '20250811165804_backfill_file_hashes',
        run: async (props: DataMigrationRunnerProps) => {
            await Backfill_file_hashes(props);
        }
    },
    {
        name: '20250912120000_migrate_chord_lyrics_to_json',
        run: async (props: DataMigrationRunnerProps) => {
            await Migrate_chord_lyrics_to_json(props);
        }
    },
];
